import { getApplication } from 'shared/redux/applicationSlice';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  isCompleted: false,
  designerDetails: {},
  verifierDetails: {},
  uploadedDocument: undefined,
};

const plantDesignDesignerVerifierSlice = createSlice({
  name: 'designerVerifier',
  initialState,
  reducers: {
    storeDesignerVerifierDetails(state, action) {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantDesignVerifier };
      });
  },
});

export const { storeDesignerVerifierDetails } = plantDesignDesignerVerifierSlice.actions;
export const plantDesignDesignerVerifierReducer = plantDesignDesignerVerifierSlice.reducer;
